import React from 'react';
import FrameHeader from './FrameHeader';
import FrameSidebar from './FrameSidebar';

const Frame = () => {
  return (
    <>
      <FrameHeader />
      <FrameSidebar />
    </>
  );
};

export default Frame;
